import githubIcon from './icons/github.svg';
import linkedinIcon from './icons/linkedin.svg';

const socialButtons = {
  'github': {
    icon: githubIcon,
    url: 'https://github.com/wgxli'
  },
  'linkedin': {
    icon: linkedinIcon,
    url: 'https://www.linkedin.com/in/samuelj-li'
  }
}

export default socialButtons;
